import { __extends } from "tslib";
import { deserializeAws_restXmlDeleteBucketCorsCommand, serializeAws_restXmlDeleteBucketCorsCommand } from "../protocols/Aws_restXml";
import { getBucketEndpointPlugin } from "@aws-sdk/middleware-bucket-endpoint";
import { getSerdePlugin } from "@aws-sdk/middleware-serde";
import { Command as $Command } from "@aws-sdk/smithy-client";
var DeleteBucketCorsCommand = /** @class */ (function (_super) {
    __extends(DeleteBucketCorsCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function DeleteBucketCorsCommand(input) {
        var _this = 
        // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
        // End section: command_constructor
    }
    DeleteBucketCorsCommand.prototype.resolveMiddleware = function (clientStack, configuration, options) {
        this.middlewareStack.use(getSerdePlugin(configuration, this.serialize, this.deserialize));
        this.middlewareStack.use(getBucketEndpointPlugin(configuration));
        var stack = clientStack.concat(this.middlewareStack);
        var handlerExecutionContext = {
            logger: {}
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function (request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    DeleteBucketCorsCommand.prototype.serialize = function (input, context) {
        return serializeAws_restXmlDeleteBucketCorsCommand(input, context);
    };
    DeleteBucketCorsCommand.prototype.deserialize = function (output, context) {
        return deserializeAws_restXmlDeleteBucketCorsCommand(output, context);
    };
    return DeleteBucketCorsCommand;
}($Command));
export { DeleteBucketCorsCommand };
//# sourceMappingURL=DeleteBucketCorsCommand.js.map